module.exports = __webpack_public_path__ + "static/media/afip@2x.2b76e657.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagenes/sobrePedraza/compra-segura/afip@2x.png
// module id = 244
// module chunks = 0